import { showAppAlert } from '../utils/alertService';
import React, { useState } from 'react';
import LoaderOverlay from './LoaderOverlay';
import '../styles/formStyles.css';

const API_URL = process.env.REACT_APP_API_BASE_URL;

function LaunchPointsModal({ visible, client, onClose, onPointsLaunched }) {
  const [purchaseValue, setPurchaseValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  
  if (!visible) return null;

  const handleSubmit = () => {
    const points = Number(purchaseValue);
    if (isNaN(points) || points <= 0) {
      showAppAlert('warning', 'Por favor, insira um valor válido.');
      return;
    }
    setShowConfirmation(true);
  };

  const handleConfirm = async () => {
    setLoading(true);
    const points = Number(purchaseValue);
    const companyId = localStorage.getItem('company_id');
    const token = localStorage.getItem('token');

    // const now = new Date();
    // //const dataVisita = now.toLocaleString('sv-SE', { timeZone: 'America/Sao_Paulo' }).replace('T', ' ');
    // const dataVisita = now.toLocaleString('sv-SE', { timeZone: 'UTC' }).replace('T', ' ');

    const payload = {
      client_id: client.id,
      company_id: companyId,
      // dataVisita: dataVisita,
      valor_compra: points,
      tipo_operacao: 'purchase',
    };

    try {
      const response = await fetch(`${API_URL}/operations`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        onPointsLaunched(client.id, points);
        setPurchaseValue('');
        setShowConfirmation(false);
        onClose();
        showAppAlert('success', 'Pontos lançados com sucesso!');
        window.location.reload();
      } else {
        showAppAlert('error', 'Erro ao lançar pontos. Tente novamente.');
      }
    } catch (error) {
      console.error('Erro ao lançar pontos:', error);
      showAppAlert('error', 'Erro ao lançar pontos. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleCancelConfirmation = () => {
    setShowConfirmation(false);
  };

  return (
    <div className="modal-overlay">
      <LoaderOverlay isLoading={loading} message="Lançando pontos..." />
      <div className="modal-content small-modal">
        <h3 style={{ borderBottom: '2px solid #C8A2C8', paddingBottom: '5px' }}>Lançar Pontos para {client?.nome}</h3>
        <div className="label-style">
          <label>Valor da Compra:</label>
          <input
            type="number"
            value={purchaseValue}
            onChange={(e) => setPurchaseValue(e.target.value)}
            className="input-style"
          />
        </div>
        <div style={{ marginTop: '15px' }}>
          <button onClick={handleSubmit} className="button-style" style={{ marginRight: '10px' }} disabled={loading}>
            {loading ? 'Lançando...' : 'Lançar'}
          </button>
          <button onClick={onClose} className="button-style cancel" disabled={loading}>
            Cancelar
          </button>
        </div>
      </div>

      {showConfirmation && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h3 style={{ borderBottom: '2px solid #C8A2C8', paddingBottom: '5px' }}>Confirmar Lançamento</h3>
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
              <p><strong>Cliente:</strong> {client?.nome}</p>
              <p><strong>Valor da Compra:</strong> R$ {Number(purchaseValue).toFixed(2)}</p>
            </div>
            <p style={{ marginBottom: '20px', color: '#666' }}>Tem certeza que deseja lançar o valor informado?</p>
            <div style={{ marginTop: '15px' }}>
              <button onClick={handleConfirm} className="button-style" style={{ marginRight: '10px' }} disabled={loading}>
                {loading ? 'Confirmando...' : 'Confirmar'}
              </button>
              <button onClick={handleCancelConfirmation} className="button-style cancel" disabled={loading}>
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default LaunchPointsModal;